var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleeDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 59.259,
    viewBox: "0 0 50 59.259",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_13849",
    "data-name": "\\uADF8\\uB8F9 13849",
    transform: "translate(-904.338 -392.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_27",
    "data-name": "\\uD569\\uCE58\\uAE30 27",
    d: "M31.649,56.437H18.8a.911.911,0,1,1,0-1.822h.567a2.386,2.386,0,0,1-1.551-2.65l1.111-6.409-4.965-3.145L12.549,45.6a2.4,2.4,0,0,1-1.9,1.408l-7.946.98a2.96,2.96,0,0,1-.305.021,2.383,2.383,0,0,1-.292-4.75l6.59-.814,2.335-5.263.034-.053L14.5,28.875l-3.473.021L7.421,31.828a2.369,2.369,0,0,1-1.133.513,2.439,2.439,0,0,1-2.25-.849,2.38,2.38,0,0,1,.339-3.353l4.271-3.47a2.38,2.38,0,0,1,1.5-.534l6.128-.046h.22l6.162,2.745.417.714,1.672,2.777H28.8a2.386,2.386,0,1,1,0,4.772H23.63a2.386,2.386,0,0,1-1.832-.859l-1.5-1.761-2.744,6.544,5.318,3.367A2.362,2.362,0,0,1,23.943,44.8l-1.393,7.987A2.381,2.381,0,0,1,21,54.615H31.649V4.552h-15.6v7.28a.916.916,0,0,1-1.832,0V3.64a.912.912,0,0,1,.915-.909H31.649V0L50,3.64v52.8L31.649,59.259ZM34.4,28.217V31.86a.918.918,0,0,0,1.836,0V28.217a.918.918,0,0,0-1.836,0ZM18.016,20.661a3.963,3.963,0,1,1,3.964,3.933A3.948,3.948,0,0,1,18.016,20.661Z",
    transform: "translate(904.338 392.498)",
    fill: "rgba(255,255,255,0.17)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleeDashboardIcon);
export default __webpack_public_path__ + "static/media/fleeDashboardIcon.7867541dec14843c5975eb929e5873a6.svg";
export { ForwardRef as ReactComponent };